import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["customRolesList", "customRoleInput"]

  addRole(event) {
    event.preventDefault();
    const roleInput = this.customRoleInputTarget;
    const roleName = roleInput.value.trim();

    if (roleName.length === 0) return;

    const listItem = document.createElement("li");
    listItem.textContent = roleName;

    // Optionally add a checkbox or any other element to manage the role
    const checkbox = document.createElement("input");
    checkbox.type = "checkbox";
    checkbox.checked = true;
    checkbox.name = "account_user[custom_role_ids][]";
    checkbox.value = roleName;

    listItem.prepend(checkbox);
    this.customRolesListTarget.appendChild(listItem);

    roleInput.value = ""; // Clear the input after adding
  }
}
